enum ActionTypes {
	request = 'MedicinalBrandsAnalytics.AtcAutocomplete.request',
	receive = 'MedicinalBrandsAnalytics.AtcAutocomplete.receive',
}

export default ActionTypes;
